import { render, staticRenderFns } from "./cTreeTable.vue?vue&type=template&id=5cd18720&scoped=true&"
import script from "./cTreeTable.vue?vue&type=script&lang=ts&"
export * from "./cTreeTable.vue?vue&type=script&lang=ts&"
import style0 from "./cTreeTable.vue?vue&type=style&index=0&id=5cd18720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd18720",
  null
  
)

export default component.exports